<template>
  <inline-svg class="signed-icon-container" :src="signedReceiptIcon" v-tooltip="signingDate"></inline-svg>
</template>

<script>
import InlineSvg from 'vue-inline-svg'
import signedReceiptIcon from '@/assets/img/icons/icon-receipt-signed.svg'
export default {
    name: 'SignedReceiptBadge',
    components: { InlineSvg },
    props: {
        signingDate: {
            type: String,
            default: ''
        }
    },
    computed: {
        signedReceiptIcon () {
            return signedReceiptIcon
        }
    }

}
</script>
<style>
.signed-icon-container {
    position: absolute;
    top: -15px;
    left: 78px;
    z-index: 9;
}

</style>
